<template>
  <div class="home-page-wrapper about-page-wrapper">
    <HeroBanner
      :title="pricing.title"
      image-url-present
      :image-url="generateImageUrl(pricing.image)"
    />
    <Social />
    <PricingTabs />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import PricingTabs from "@/pageComponents/pricing/pricing-tabs";
import Social from '@/pageComponents/social/Social'
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "Pricing",
  mounted() {},
  computed: {
    ...mapGetters({
      pricing: `${MISC_STORE_KEY}/pricing`
    })
  },
  components: {
    HeroBanner,
    PricingTabs,
    Social
  }
};
</script>

<style></style>
